import DocumentTable from './DocumentTable';
export { default as ActionAddDocuments } from './ActionAddDocuments';
export default DocumentTable;
